export default __webpack_public_path__ + "static/media/nr.c8415592.svg";